module.exports = __webpack_public_path__ + "img/ETFvsSPQR.9b34ec9e.png";